import { Injectable } from '@angular/core';
import { LoginAuthenticationService } from './login-authentication.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AdminRouteGuardService {

  auth:boolean;
  userRoles: any;
  roles: string;
  
  constructor(private loginAuthenticationService:LoginAuthenticationService, private router: Router) { }
 
   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  
    if (this.loginAuthenticationService.isUserLoggedIn()){

      let isAdmin = sessionStorage.getItem('Admin');
      
      if(isAdmin == 'Y')
        return true;
      else
        this.router.navigate(['accessDenied']);
    }else{
       this.router.navigate(['login']);
       return false;
     }
   }

}
